import ApplicationEventNames from '@/ship/Enums/ApplicationEventNames';
import { Vue } from 'vue-property-decorator';
// export const LoadingBus = new Vue();

class LoadingService extends Vue {
    private active: Set<string> = new Set();

    start(key: string) {
        this.active.add(key);
        this.update();
    }

    stop(key: string) {
        this.active.delete(key);
        this.update();
    }

    private update() {
        this.$bus.emit(ApplicationEventNames.SetAdministrationLoading, this.active.size > 0);
    }
}

export const loadingService = new LoadingService();
